module.exports = __webpack_public_path__ + "static/media/twitter.40478183.svg";